import request from '@/utils/request'

export function selectPmPriceBargainInfoById(obj) {
  return request({
    url: '/api/srm-slcm/pmPriceBargainInfo/selectPmPriceBargainInfoById',
    method: 'post',
    data: obj
  })
}

export function getStruCrop() {
  return request({
    url: '/api/srm-base/struCorp/getStruCrop',
    method: 'get'
  })
}

export function getMdmCatgrByLevel(data) {
  return request({
    url: '/api/srm-base/mdmCatg/getMdmCatgrByLevel',
    method: 'get',
    params: data
  })
}

export function selectHistoryPice(data, historyPrice) {
  return request({
    url: `/api/srm-base/mdmMatHistoryPrice/selectHistoryPice/${historyPrice}`,
    method: 'post',
    data
  })
}
